import { AxiosInstance } from 'axios';
import { Currency } from 'dinero.js';
import baseAxios from '@/helpers/forms/axios';
import exchangeRatesFactory from './exchangeRates';

export default (axios: AxiosInstance = baseAxios): { exchangeRates: { fetchExchangeRates: (baseCurrency: Currency) => Promise<{ [key: string]: number; }>; }; } => ({
    exchangeRates: exchangeRatesFactory(axios),
});
